import React, {Fragment,useEffect,useId,useRef,useState} from 'react'

import axios from 'axios'
import Btn from './ui/Btn'
import './protected/settings.css'

/*
 * The video-server uploader that sits at the top of the video library.
 *
 * Contract unchanged: <FileUpload addNewVideo={...} nvl={...} type="1"/>, and the
 * POST still goes to whichever endpoint `type` selects, with the same FormData
 * (file / token / app). Only the surface changed — token-styled controls, a real
 * progress bar, and inline messages instead of alert().
 */

const IconPaperclip=()=>(
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M21 11.5 12.5 20a5 5 0 0 1-7-7l8-8a3.5 3.5 0 0 1 5 5l-8 8a2 2 0 0 1-3-3l7.5-7.5"/>
  </svg>
)

const FileUpload = (props) => {

    const [file,setFile]=useState('')
    const [fileName,setFileName]=useState('Please select an MP4 file')
    const [upLoading, setUpLoading]=useState(false)
    const [uploadPercentage, setUploadPercentage]=useState(0)
    const [url,setUrl]=useState('')
    const [title,setTitle]=useState('')
    const [note,setNote]=useState(null)

    const inputRef=useRef(null)
    const inputId='st-upv-'+useId()

    useEffect(() => {
        if (props.type==1){
            setUrl(process.env.REACT_APP_VIDEOSERVER_API+'upload')
            setFileName('Please select an MP4 file')
            setTitle('Upload Video (.MP4 format only)')
        }

        if (props.type==2){
            setUrl(process.env.REACT_APP_API_SERVER+'uploadtrainerphoto.php?id='+props.id)
            setFileName('Please select an image file')
            setTitle('Upload Trainer Photo.')
        }

        if (props.type==3){
            setUrl(process.env.REACT_APP_API_SERVER+'uploadprogramphoto.php?id='+props.id)
            setFileName('Please select an image file')
            setTitle('Upload Program Photo.')
        }
        if (props.type==4){
            setUrl(process.env.REACT_APP_API_SERVER+'uploadprogramcategoryphoto.php?id='+props.id)
            setFileName('Please select an image file')
            setTitle('Upload Program Category Photo.')
        }

        if (props.type==5){
            setUrl(process.env.REACT_APP_API_SERVER+'uploadvideophoto.php?id='+props.id)
            setFileName('Please select an image file')
            setTitle('Upload Video Photo.')
        }

    }, [props.type])

    const emptyName=()=>(props.type==1 ? 'Please select an MP4 file' : 'Please select an image file')

    const resetPicker=()=>{
        if (inputRef.current) inputRef.current.value=null
        setFile('')
        setFileName(emptyName())
    }

    const fileChanged=e=>{
        setNote(null)
        const picked=e.target.files && e.target.files[0]
        if (!picked){
            resetPicker()
            return
        }

        if (props.type==1){
            if (picked.type=='video/mp4'){
                setFile(picked)
                setFileName(picked.name)
            }else{
                resetPicker()
                setNote({tone:'crit',text:'Please Select MP4 file'})
            }
        }

        if (props.type==2 || props.type==3 || props.type==4 || props.type==5){
            if (String(picked.type||'').indexOf('image/')>-1){
                setFile(picked)
                setFileName(picked.name)
            }else{
                resetPicker()
                setNote({tone:'crit',text:'Please Select an IMAGE file'})
            }
        }
    }

    const uploadFile=async e=>{
        e.preventDefault()
        setNote(null)
        const formData=new FormData()
        formData.append('file',file)
        formData.append('token',process.env.REACT_APP_API_TOKEN)
        formData.append('app',process.env.REACT_APP_NAME)
        try{
            setUpLoading(true)
            axios.post(url,formData,{
                headers:{
                    'Content-Type':'multipart/form-data'
                },
                onUploadProgress: ProgressEvent=>{
                    setUploadPercentage(parseInt(Math.round(ProgressEvent.loaded*100/ProgressEvent.total)))
                }
            }).then(res=>{
                setUpLoading(false)
                resetPicker()

                setUploadPercentage(0)

                if (res.data.err==0){
                    const newVideo={
                        id:res.data.id,
                        status:0,
                        duration:0
                    }
                    props.addNewVideo(newVideo)
                }else{
                    setNote({tone:'crit',text:'An Error has occured! Please Try Again'})
                }
            }).catch(err=>{
                setUpLoading(false)
                setUploadPercentage(0)
                setNote({tone:'crit',text:'The upload failed. Please check your connection and try again.'})
                console.log(err)
            })

        }catch(err){
            setUpLoading(false)
            setUploadPercentage(0)
            setNote({tone:'crit',text:'The upload failed. Please check your connection and try again.'})
            console.log(err)
        }
    }

    return (

        <Fragment>
          <div className="st-up">

            <div className="st-up-head">
              <span className="mono st-up-title">{title}</span>
              <span className="st-up-sub">
                {props.type==1
                  ? 'The file is transcoded on the video server; it appears in the library once processing finishes.'
                  : 'The image replaces whatever is stored for this record.'}
              </span>
            </div>

            {note
              ? <div className="st-note" data-tone={note.tone} role="alert">
                  <span className="st-note-text">{note.text}</span>
                </div>
              : null}

            <form className="st-up-form" onSubmit={uploadFile}>
              <div className="st-file-row">
                <input
                  ref={inputRef}
                  className="st-file"
                  required
                  onChange={fileChanged}
                  type="file"
                  accept={props.type==1 ? 'video/mp4' : 'image/*'}
                  id={inputId}
                />
                <label className="st-file-label" htmlFor={inputId}>
                  <IconPaperclip/>
                  Choose file
                </label>
                <span className="st-file-name" data-set={file ? '1' : '0'}>{fileName}</span>
              </div>

              {upLoading
                ? <div>
                    <div className="st-up-progress">
                      <span className="st-up-fill" style={{width:uploadPercentage+'%'}}></span>
                    </div>
                    <div className="st-up-pct">
                      <b>{uploadPercentage}%</b>
                      <span>Uploading — please wait.</span>
                    </div>
                  </div>
                : null}

              <div className="st-up-actions">
                <Btn variant="accent" type="submit" disabled={upLoading}>
                  Upload {props.type==1 ? 'Video' : 'Photo'}
                </Btn>
              </div>
            </form>

          </div>
        </Fragment>
    )

}

export default FileUpload;
